import { FC } from 'react';
import { cn } from '@/utils/cn';

interface SidebarProps {
  activeSection: string;
  onSectionChange: (section: string) => void;
  className?: string;
}

const sections = [
  { id: 'windows', title: 'Claude - Windows 安装', icon: '🪟', category: 'claude' },
  { id: 'macos', title: 'Claude - macOS/Linux 安装', icon: '🍎', category: 'claude' },
  { id: 'configuration', title: 'Claude - 配置 API Key', icon: '🔑', category: 'claude' },
];

export const Sidebar: FC<SidebarProps> = ({ 
  activeSection, 
  onSectionChange, 
  className 
}) => {
  const claudeSections = sections.filter(s => s.category === 'claude');

  return (
    <nav className={cn('bg-white rounded-lg shadow-sm border border-gray-200 p-4', className)}>
      <h3 className="font-semibold text-gray-900 mb-4">安装指南</h3>

      {/* Claude 安装教程 */}
      <div className="mb-4">
        <h4 className="text-sm font-medium text-gray-500 mb-2 flex items-center">
          <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
          Claude Code
        </h4>
        <ul className="space-y-1">
          {claudeSections.map((section) => (
            <li key={section.id}>
              <button
                onClick={() => onSectionChange(section.id)}
                className={cn(
                  'w-full text-left px-3 py-2 rounded-lg transition-colors flex items-center space-x-3',
                  activeSection === section.id
                    ? 'bg-blue-100 text-blue-700 font-medium'
                    : 'text-gray-700 hover:bg-gray-100'
                )}
              >
                <span className="text-lg">{section.icon}</span>
                <span className="text-sm">{section.title.replace('Claude - ', '')}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      
      {/* <div className="mt-6 pt-4 border-t border-gray-200">
        <div className="bg-blue-50 rounded-lg p-3">
          <h4 className="font-medium text-blue-900 text-sm mb-1">需要帮助？</h4>
          <p className="text-blue-800 text-xs mb-2">联系我们的技术支持</p>
          <p className="text-blue-700 text-xs font-mono">386740421@qq.com</p>
        </div>
      </div> */}
    </nav>
  );
};